import React from 'react'
import {Button} from 'reactstrap'
import * as Icon from 'react-feather'
import "../batch/Batch.scss"

const LockButton = ({
    isDisabled,
    onReset,
    onToggle,
}) => {
    // Unlock(Mark red) is editing or removing UTM, Lock is no changes.
    // Lock will clean the value of input/selection
    return (
        <Button color="link" className='lock-button' onClick={() => {
            onReset()
            onToggle(isDisabled)
        }}>
            {isDisabled ? <Icon.Lock/> : <Icon.Unlock  color='red'/>} 
        </Button>)
}

export default LockButton